import React from "react";
import Header from "../Components/Header/Header";
import BinStatus from "../Components/BinStatus/BinStatus";
import BinTable from "../Components/Tables/BinTable";
import GoBackButton from "../Components/Buttons/GoBackButton";
import DetailsPageHead from "../Components/PageHead/DetailsPageHead";
import BinDetailComp from "../Components/DetailsPageComp/BinDetailComp";


const RouteDetails = ()=> {
    return(
        <>
            <Header />
            <div className="max-w-screen-xl px-4 mx-auto">
                <GoBackButton />
                <div className="">
                    <DetailsPageHead pageDetHeading={'Route#1222'} />
                </div>  
                <div className="mt-9">
                    <BinDetailComp heading={'Starting Point:'} detail={'Lorem ipsum'}/>
                    <BinDetailComp heading={'End Point:'} detail={'Lorem ipsum'}/>
                    <BinDetailComp heading={'Status:'} detail={'Active'}/>
                    <BinDetailComp heading={'Time Take:'} detail={'30min'}/>
                    <BinDetailComp heading={'Last Updated:'} detail={'12-03-2023 9:00AM'}/>
                    <BinDetailComp heading={'Location:'} detail={'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur error labore sint vel molestias iste fugiat culpa, quae ullam nulla, blanditiis soluta ducimus repellendus, qui eum minima possimus illo delectus.'}/>
                    
                </div>
            </div>
        </>
    )
}

export default RouteDetails